export const ro = {
  nav: { home: "Acasă", services: "Servicii", fleet: "Flotă", pricing: "Tarife", blog: "Blog", contact: "Contact", book: "Rezervă", call: "Sună", cities: "Destinații" },
  hero: {
    overline: "LUXURY VTC RIVIERA",
    title: "Șoferul tău privat pe",
    titleAccent: "Coasta de Azur",
    subtitle: "Servicii VTC premium în Nisa, Monaco, Cannes și pe toată Riviera Franceză. Transferuri aeroport, evenimente și călătorii personalizate 24/7.",
    cta1: "Rezervă acum", cta2: "Cere ofertă",
    badge1: "Disponibil 24/7", badge2: "Șofer certificat", badge3: "Tarife transparente",
    clarityOverline: "Șofer privat VTC · Nisa & Coasta de Azur",
    clarityText: "Transferuri aeroport, Monaco, Cannes, Antibes, Saint-Tropez. Preț calculat pe traseul real.",
    point1: "Preț pe traseul real",
    point2: "Ofertă în 2 min",
    point3: "Fără cont obligatoriu",
  },
  home: {
    heroOverline: "VTC Eco · Nisa & Coasta de Azur",
    heroTitle: "VlaDriver VTC — Șofer Privat Eco-Responsabil pe Coasta de Azur",
    heroSubtitle: "Confort premium într-o flotă 100% Hibridă (Toyota C-HR & Corolla Cross). Tarife fixe garantate, cunoscute dinainte.",
    heroBadge: "5,0/5 · Cel mai bine cotat șofer pe Google",
    heroCtaPrice: "Vezi tarifele",
    heroCtaBook: "Cere tariful meu fix",
    pricingOverline: "Forfait-uri totul inclus",
    pricingTitle: "Tarife fixe garantate",
    pricingSubtitle: "Prețul este cunoscut dinainte. Fără surprize, fără aparat de taxat.",
    pricingAllInc: "Totul inclus",
    pricingOnRequest: "Tarif la cerere",
    pricingNote: "Taxe de drum, întâmpinare și bagaje incluse. Supliment de noapte (23–6) și duminică/sărbători: +15%.",
    leadOverline: "Cerere de tarif",
    leadTitle: "Cere tariful tău fix",
    leadSubtitle: "Doar 4 câmpuri — răspuns rapid prin telefon sau WhatsApp.",
    leadName: "Nume & Prenume",
    leadPhone: "Telefon / WhatsApp",
    leadPickup: "Punct de plecare",
    leadDestination: "Destinație",
    leadSubmit: "Rezervă prin WhatsApp",
    leadSending: "Se trimite...",
    leadSuccessTitle: "Cerere trimisă ✓",
    leadSuccessBody: "Mulțumim! Te contactăm foarte curând. Poți finaliza imediat pe WhatsApp.",
    leadWhatsapp: "Continuă pe WhatsApp",
    leadError: "A apărut o eroare. Reîncearcă sau sună-ne la +33 7 83 97 73 70.",
    reviewsOverline: "Recenzii clienți",
    reviewsTitle: "5,0/5 pe Google",
    reviewsSubtitle: "Cotat cu 5 stele de clienții noștri pe toată Coasta de Azur.",
    reviewsCta: "Vezi recenziile Google",
    waReserve: "Rezervă prin WhatsApp",
    quickRoutes: "Trasee populare:",
    widgetTitle: "Rezervă-ți șoferul",
    widgetSubtitle: "Introdu traseul, vezi tariful, plătești online în 1 min.",
    googleContinue: "Continuă cu Google",
    bookDate: "Data",
    bookTime: "Ora",
    bookEmail: "Email",
    priceComputing: "Se calculează tariful…",
    priceLabel: "Tariful tău",
    priceAllInc: "totul inclus",
    priceError: "Nu pot calcula acest traseu. Precizează adresele.",
    enterTripForPrice: "Introdu plecarea și destinația ca să vezi tariful.",
    payNow: "Rezervă și Plătește",
    payRedirect: "Redirecționare către plată…",
    paySecure: "Plată securizată · Cursă confirmată instant",
    paymentSoon: "Rezervarea ta e salvată. Plata online va fi activă foarte curând — te contactăm pentru finalizare.",
    payError: "A apărut o eroare. Reîncearcă.",
    payChecking: "Se verifică plata…",
    paySuccessTitle: "Rezervare confirmată ✓",
    paySuccessBody: "Cursa ta e rezervată și plătită. Pe curând!",
    payPendingTitle: "Plată în curs…",
    payPendingBody: "Finalizăm plata ta. Pagina se actualizează automat.",
    payFailedTitle: "Plata nu a reușit",
    payFailedBody: "Plata nu a putut fi finalizată. Poți reîncerca.",
    payRetry: "Reîncearcă",
    orderTime: "Comandă plasată la",
    parisTime: "(ora Franței)",
    paidTime: "Plătită la",
    backHome: "Înapoi acasă",
  },
  booking: {
    title: "Rezervare rapidă", subtitle: "Primește oferta în mai puțin de 2 minute",
    quoteBadge: "— Cerere ofertă",
    heading: "Rezervă transferul",
    subheading: "Ofertă personalizată trimisă în 15 minute",
    pickup: "Loc de preluare", pickupPh: "Aeroport, hotel, adresă...",
    destination: "Destinație", destinationPh: "Monaco, Cannes, hotel...",
    date: "Data", time: "Ora", passengers: "Pasageri", luggage: "Bagaje",
    name: "Nume complet", phone: "Telefon", email: "Email (opțional)",
    flight: "Număr zbor (opțional)", message: "Mesaj sau cerere specială",
    vehicle: "Vehicul",
    chrDesc: "Hibrid · 4 pax",
    corollaDesc: "Berlină · 4 pax",
    submit: "Confirmă rezervarea",
    requestQuote: "Cere o ofertă",
    confirmBooking: "Confirmă rezervarea",
    confirmedTitle: "Rezervare confirmată",
    firmPriceLabel: "Preț ferm",
    tollsIncluded: "Preț total, taxe de autostradă incluse",
    confirmedBody: "Gata! Vlad te contactează în scurt timp pentru ultimele detalii.",
    confirmedBodyNoPrice: "Cererea ta e înregistrată. Vlad te recontactează în 15 min cu prețul și detaliile.",
    signInToQuote: "Autentifică-te pentru a cere oferta",
    success: "Rezervare trimisă! Te contactăm în maxim 15 minute.",
    error: "Eroare. Te rugăm reîncearcă sau sună direct.",
    successTitle: "Cerere primită",
    successBody: "Îți trimitem o ofertă personalizată în {{min}}.",
    successNote: "Vei primi prețul în contul tău — semnătură electronică necesară pentru confirmare.",
    successNoteGuest: "Vlad îți confirmă prețul și ora prin telefon sau email. Fără cont necesar.",
    viewMyRequest: "Vezi cererea mea",
    newRequest: "Cerere nouă",
    quoteInfoTitle: "Ofertă personalizată",
    quoteInfoBody: "Preț {{fixedPrice}} afișat pe traseul real, rezervare confirmată imediat.",
    quoteInfoBodyFixed: "ferm",
    quoteInfoNote: "Preț total, taxe de autostradă incluse. Fără cont necesar.",
    estimateBtn: "Estimează prețul",
    estimateLoading: "Se calculează…",
    estimateMissing: "Completează locul de preluare și destinația.",
    estimateUnavailable: "Estimare indisponibilă.",
    estimateNetworkError: "Eroare de rețea. Reîncearcă.",
    estimateHeading: "Prețul cursei",
    estimateTrip: "Traseu",
    estimateDisclaimer: "Preț ferm calculat pe traseul real, taxe de autostradă incluse.",
    estimateTollsNote: "Prețul total, inclusiv taxele de autostradă, este comunicat în ofertă înainte de acceptare",
    estimateAirportNote: "Taxă aeroport inclusă",
    estimateNightNote: "Tarif de noapte (23:00 – 06:00) aplicat",
    estimateIncludedNote: "Placardă nume și bagaje incluse",
    reminderOptinTitle: "Nu ai timp acum?",
    reminderOptinSubtitle: "Îți trimitem o reamintire a acestei oferte în 15 min, direct pe acest telefon.",
    reminderOptinCta: "Activează",
    reminderActive: "Reamintire activată — îți trimitem notificarea în 15 min.",
  },
  services: {
    title: "Serviciile noastre VTC",
    subtitle: "O flotă premium pentru fiecare deplasare",
    airport: { title: "Transfer Aeroport Nisa", desc: "Întâmpinare personalizată cu placardă nominală. Urmărire zbor în timp real." },
    monaco: { title: "Nisa ↔ Monaco", desc: "Drum direct spre Principat în mai puțin de 30 minute. Ideal pentru Marele Premiu și evenimente VIP." },
    cannes: { title: "Nisa ↔ Cannes", desc: "Serviciu privilegiat pentru Festival, Mipim și gale. Discreție și punctualitate." },
    business: { title: "Transport Business", desc: "Disponibilitate la oră sau zi. Roadshow-uri, seminarii, deplasări profesionale." },
    luxury: { title: "Hoteluri de lux", desc: "Partener al palatelor de pe Rivieră: Negresco, Carlton, Hermitage, Hôtel de Paris." },
    events: { title: "Nunți & Evenimente", desc: "Transport elegant pentru invitați. Pachete personalizate." },
    cruise: { title: "Croaziere", desc: "Transferuri de la/spre porturile Nisa, Cannes, Villefranche, Monaco." },
    hourly: { title: "Disponibilitate orară", desc: "Șofer la dispoziție pentru shopping, vizite, întâlniri." },
  },
  pricing: { title: "Tarife transparente", subtitle: "Prețuri fixe pentru cele mai cerute trasee", duration: "Durată", price: "Preț", quote: "Ofertă personalizată", note: "Prețuri indicative TVA inclus pentru o limuzină până la 4 pasageri." },
  fleet: {
    title: "Flota noastră", subtitle: "Două vehicule premium: Toyota C-HR & Toyota Corolla 2026",
    feat1: "Climatizare bi-zonă", feat2: "Scaune piele", feat3: "Confort premium la bord",
    feat4: "Încărcătoare USB", feat5: "Bluetooth audio", feat6: "Vehicul hibrid eco",
  },
  trust: {
    title: "De ce VlaDriver?",
    stat1: { num: "5+", label: "Ani experiență" },
    stat2: { num: "10K+", label: "Clienți mulțumiți" },
    stat3: { num: "4.9/5", label: "Notă medie" },
    stat4: { num: "24/7", label: "Disponibilitate" },
    feat1: "Șofer VTC certificat (card profesional)",
    feat2: "Asigurare premium toate riscurile",
    feat3: "Prețuri fixe, fără surprize",
    feat4: "Plată card, cash sau transfer",
    feat5: "Multilingv: Franceză, Engleză, Italiană, Română",
    feat6: "Anulare gratuită până la 12h înainte",
  },
  testimonials: { title: "Au încredere în noi", subtitle: "Recenzii verificate" },
  faq: { title: "Întrebări frecvente", subtitle: "Tot ce trebuie să știi" },
  cta: { title: "Gata pentru următoarea cursă?", subtitle: "Rezervă în 2 minute sau sună direct", book: "Rezervă online", whatsapp: "WhatsApp" },
  footer: {
    tagline: "Șofer Privat Premium — Nisa & Coasta de Azur",
    serviceTitle: "Servicii", cityTitle: "Destinații", blogTitle: "Blog & Sfaturi", contactTitle: "Contact",
    legal: "Mențiuni legale", privacy: "Confidențialitate", cgv: "Termeni", rights: "Toate drepturile rezervate.",
    siret: "SIRET în curs", license: "Licență VTC oficială",
  },
  common: { readMore: "Citește mai mult", backHome: "Înapoi acasă", minutes: "min", from: "De la", quote: "La cerere" },
};
